import React, { useContext, useEffect, useRef, useState,useTransition } from "react";
import { Page_settings } from "../../config/page_settings";
import { IClassList } from "../../type/classroom";
import { IMemberInfo } from "../../type/member";
import { useNavigate } from "react-router-dom";
import { rootStore } from "../../mobx/store";
import { observer } from "mobx-react";
import styled from "styled-components";
import colors from "../../design/colors";
import fonts from "../../design/typography";
import { Client } from "@stomp/stompjs";
import SockJS from "sockjs-client";
import { SOCKET_URL } from "../../config/const";
import BasicDropdown from "../header/dropdown/Basic_dropdown";
import ExitIcon from "../icons/exit";

/* **********************************
 * COMPONENT
 * 컴포넌트 정의
 ********************************** */
const Header = () => {
  /* **********************************
   * GLOBAL STATE
   * 전역 상태 및 전역 변수
   ********************************** */
  const context: any = useContext(Page_settings);
  const token = rootStore.token;
  const navigate = useNavigate();

  /* **********************************
   * LOCAL STATE
   * 컴포넌트 내부에서 사용하는 상태
   ********************************** */
  const [classList, setClassList] = useState<IClassList[]>([]);
  const [memberInfo, setMemberInfo] = useState<IMemberInfo | null>(null);
  const [socketClient, setSocketClient] = useState<Client | null>(null);

  const [, startTransition] = useTransition();

  /* **********************************
   * HANDLERS
   * 사용자 입력 및 이벤트 처리
   ********************************** */
  const refetchMemberInfo = () => {
    context.get("/member/info", {}, (response) => {
      setMemberInfo(response);
    });
  };

  /* **********************************
   * USE EFFECT
   * 컴포넌트 렌더링 시 실행되는 함수
   ********************************** */

  return (
    <HeaderWrapper>
      <section style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <BasicDropdown
          label="시스템관리자 님"
          options={[
            {
              label: "로그아웃",
              icon: <ExitIcon />,
              onClick: () => {
                startTransition(() => {
                  rootStore.signOut();
                  navigate("/login");
                });
              },
            },
          ]}
        />
      </section>
    </HeaderWrapper>
  );
};

/* **********************************
 * STYLE
 * 스타일 정의
 ********************************** */
const HeaderWrapper = styled.div`
  width: 100%;
  height: 80px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: end;
  padding: 0 60px;
  background-color: ${colors.white};
  z-index: 5;
  position: relative;
  border-bottom: 1px solid ${colors.gray100};

  ${({ theme }) => theme.device.mobile} {
    padding: 0 20px;
    height: 50px;
  }
`;

export default observer(Header);
